import { useSelector } from 'react-redux';

import userSlice from '../../store/user';

const useAuth = () => useSelector(userSlice.selectors.isAuthenticated);

export default useAuth;
